import { Attr, Model } from "spraypaint";

import { ApplicationRecord } from "shared/services/spraypaint";

@Model()
class Holiday extends ApplicationRecord {
  static jsonapiType = "holidays";

  @Attr({ persist: false }) archivedAt: string;

  @Attr() date: string;

  @Attr() name: string;

  @Attr() notes: string;
}

export default Holiday;
